import { Dropdown } from 'antd';
import { DropDownProps } from 'antd/lib/dropdown';
import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';
import './VtxDropdown.scss';
import { VtxButton, VtxButtonProps } from '../button/VtxButton';
import { VtxIcon } from '../icon/VtxIcon';

interface ButtonForDropdownProps extends Omit<VtxButtonProps, 'type' | 'iconDirection'> {
    type?: 'primary' | 'default';
    iconDirection?: 'left';
}

export interface VtxDropdownButtonProps
    extends Omit<DropDownProps, 'type' | 'icon' | 'children' | 'buttonsRender'>,
        IAutomatable {
    btnProps?: ButtonForDropdownProps;
}

export const VtxDropdownButton: FunctionComponent<VtxDropdownButtonProps> = React.memo(
    (props: VtxDropdownButtonProps) => {
        const automationClass = 'vtx-dropdown-button';
        const { className, disabled, btnProps, ...otherProps } = preventDataAutomationOverriding(props);
        const classNamesCombined = classNames(automationClass, className);
        return (
            <div className={classNamesCombined} data-automation-class={automationClass}>
                <Dropdown disabled={disabled} className={classNamesCombined} {...otherProps}>
                    <VtxButton {...btnProps} title={undefined}>
                        {btnProps?.title}
                        <VtxIcon className="vtx-dropdown-button-down-arrow-icon" type="down" />
                    </VtxButton>
                </Dropdown>
            </div>
        );
    }
);
